import { createAppWrap } from '../../../create_app_wrap';
import childPageCommonMixin from '../_mixin';

const PAGES = [
    // 概要
    'SUMMARY',
    // アカウントを作る
    'CREATE_ACCOUNT',
    // あとで作る場合の手順
    'CREATE_LATER',
    // 今作る場合の手順
    'CREATE_NOW',
];

const view = '[data-view="guide-opening-storematch"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                // 最初のページ
                page: PAGES[0],
            };
        },
        computed: {
            // ページ表示順番号(index)
            pageIndex () {
                return PAGES.indexOf(this.page);
            },
        },
        mixins: [
            childPageCommonMixin,
        ],
        methods: {
            // 次画面へ
            next () {
                this.page = PAGES[this.pageIndex + 1];
                window.scroll(0, 0);
            },
            // 前画面へ
            prev () {
                if (this.pageIndex === 0) {
                    window.location.href = '/guide/opening';
                } else {
                    // 「今作る」画面から戻る場合は「アカウントを作る」画面へ戻す
                    if (this.page === 'CREATE_NOW') {
                        this.page = 'CREATE_ACCOUNT';
                    } else {
                        this.page = PAGES[this.pageIndex - 1];
                    }
                    window.scroll(0, 0);
                }
            },
            // 「今作る」画面へ
            createNow () {
                this.page = 'CREATE_NOW';
            },
        }
    });
};


const find = (document.querySelector(view));
if (find) {
    init(); 
}
// 読み込み先でinitしたか判定できるようにする
export const initialized = find;